module.exports = __webpack_public_path__ + "static/media/arrow-left.93ff9474.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-left.svg
// module id = 424
// module chunks = 1